import script from "./CertificationMain.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificationMain.vue?vue&type=script&setup=true&lang=js"

import "./CertificationMain.vue?vue&type=style&index=0&id=de9afc9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de9afc9a"]])

export default __exports__